module.exports = __webpack_public_path__ + "portal-static/img/pdf.e2b439d4.png";